import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import styles from './ReasonChoices.module.scss'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import { Reason } from './Reason/Reason'
import asideModalStore from 'Stores/asideModalStore'
import AddReason from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/AddReason/AddReason'
import swal from 'sweetalert'

export const ReasonChoices = ({ translate }) => {
  const [reasons, setReasons] = useState([])

  const fetchReasons = async () => {
    try {
      const { data } = await superAxiosRequest({
        link: `settings/project_settings/deal_reject_reason_choices`,
        method: 'get',
        crm: true,
      })
      if (data?.value?.choices) {
        setReasons(data.value.choices)
      }
    } catch (error) {
      console.error('Ошибка загрузки причин:', error)
    }
  }

  useEffect(() => {
    fetchReasons()
  }, [])

  const updateReasons = async (updatedChoices) => {
    try {
      const payload = {
        value: {
          choices: updatedChoices,
        },
      }

      const response = await superAxiosRequest(
        {
          link: `settings/project_settings/deal_reject_reason_choices`,
          method: 'put',
          crm: true,
        },
        payload,
      )

      await fetchReasons()
    } catch (error) {
      console.error('Полная ошибка:', {
        message: error.message,
        response: error.response?.data,
        config: error.config,
      })
      throw error
    }
  }

  const addReason = () => {
    const ms = {
      modalBodyComponent: () => <AddReason />,
      button: 'Save',
      link: 'settings/project_settings/deal_reject_reason_choices',
      title: 'Add a reason',
      isCenter: true,
      is_put: true,
      crm: true,
      onBeforeSubmit: (data) => {
        const newReason = {
          id: reasons.length + 1,
          name: data.value,
        }
        return {
          value: {
            choices: [...reasons, newReason],
          },
        }
      },
      onSubmitSuccess: fetchReasons,
      valid: { value: 'required' },
    }
    asideModalStore.activity(ms)
  }

  const editReason = (reason) => {
    const ms = {
      modalBodyComponent: () => <AddReason initialValue={reason.name} />,
      button: 'Сохранить',
      link: 'settings/project_settings/deal_reject_reason_choices',
      title: 'Edit the reason',
      isCenter: true,
      is_put: true,
      crm: true,
      onBeforeSubmit: (data) => {
        const updated = reasons.map((r) =>
          r.id === reason.id ? { ...r, name: data.value } : r,
        )
        return {
          value: {
            choices: updated,
          },
        }
      },
      onSubmitSuccess: fetchReasons,
      valid: { value: 'required' },
    }
    asideModalStore.activity(ms)
  }

  const deleteReason = (reasonId) => {
    swal({
      title: 'Вы уверены?',
      text: 'После удаления причину нельзя будет восстановить.',
      icon: 'warning',
      buttons: {
        cancel: {
          text: 'Отмена',
          value: null,
          visible: true,
        },
        confirm: {
          text: 'Удалить',
          value: true,
          className: 'swal-button--danger',
        },
      },
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const updated = reasons.filter((r) => r.id !== reasonId)
          await updateReasons(updated)
          swal('Успешно!', 'Причина была удалена.', 'success')
        } catch (error) {
          swal('Ошибка!', 'Не удалось удалить причину.', 'error')
          console.error('Ошибка удаления:', error)
        }
      }
    })
  }

  const action = (actionType, e, items) => {
    const actions = new Map([
      ['edit_reason', () => editReason(items)],
      ['delete_reason', () => deleteReason(items.id)],
    ])
    return actions.get(actionType)?.()
  }

  const menu = [
    { name: translate.edit, action: 'edit_reason' },
    { name: translate.delete, action: 'delete_reason' },
  ]

  return (
    <div className={styles.reasonsContainer}>
      <div className={styles.header}>
        <PageHeader title={translate.refusal} />
        <div className={styles.settingsLocalization__box}>
          <HeaderAddButton title={translate.add_reason} onClick={addReason} />
        </div>
      </div>
      {reasons.length === 0 ? (
        <div className={styles.noReasons}>There are no added reasons</div>
      ) : (
        reasons.map((reason, index) => (
          <Reason
            key={reason.id + index}
            reason={reason}
            action={action}
            index={index}
            menu={menu}
          />
        ))
      )}
    </div>
  )
}
